import { sdk as createBffSdk } from '@invivodf/module-appro-bff-sdk/dist/bff.sdk'
import { getConfig } from '@b2ag/micro-front-tools'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { CheckoutV2Service } from './checkout-v2.service'
import { accessTokenSource, createFrontAxiosClient } from '@b2ag/axios-client'
import { customerApiClientFactory } from '@b2ag/module-universcoop-sdk'

const cartApiHost = getConfig('CART_API_HOST')
const userApiHost = getConfig('USER_API_HOST')
const checkoutApiHost = getConfig('ORDER_API_HOST')

const callerId = buildCallerId()

const bffSdk = createBffSdk(cartApiHost, { callerId, accessTokenSource })

const checkoutApi = createFrontAxiosClient(`${checkoutApiHost}/v1`)

const customerApiClient = customerApiClientFactory(userApiHost, { callerId, accessTokenSource })

const checkoutV2Service = new CheckoutV2Service(bffSdk, checkoutApi, customerApiClient)

export { checkoutV2Service }
export * from './checkout-names.mapper'
export { type Order } from './checkout-v2.service'
